<template lang="pug">
.row.form-group.time-entry-info
  .col-xs-6.pr-0
    .col-xs-12
      label.control-label Member
    .col-xs-12.ellipsis.pr-0
      AppAvatar(
        :avatar="userAvatarUrl"
        size="medium"
      )
      span {{ user.name }}
  .col-xs-6.pr-0
    .col-xs-12
      label.control-label
        | {{ projectTaskLabel }}
    .col-xs-12.pr-15
      AppAvatarInitial(
        v-if="projectName"
        :text="projectName"
      )
      .inline-block
        .project
          .inline-block
            .name
              | {{ projectName }}
        .hi-12.text-lighter.task
          | {{ taskName }}
  .col-xs-12.mt-5
    .col-xs-12
      label.control-label Time Span
    .col-xs-12
      | {{ timeEntry.start_time | formatDate }}
      span.text-lighter.m-5 from
      | {{ timeEntry.start_time | formatTime }}
      span.text-lighter.m-5 to
      | {{ timeEntry.stop_time | formatTime }}
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'TimeEntriesTimeEntryInfo',
  props: {
    timeEntry: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['user', 'userAvatarUrl', 'getProject', 'getTask']),
    projectTaskLabel() {
      if (this.project && this.project.work_order) {
        return this.task ? 'Work order / Job' : 'Work order';
      }

      return this.task ? 'Project / To-do' : 'Project';
    },
    project() {
      return this.getProject(this.timeEntry.project_id);
    },
    projectName() {
      if (this.project) {
        return this.project.text;
      }

      return null;
    },
    task() {
      return this.getTask(this.timeEntry.task_id);
    },
    taskName() {
      return this.task ? this.task.text : '';
    },
  },
};
</script>
